import React from "react";
import i18n from "../../../i18n";

import { Tag } from "@blueprintjs/core";

import { userColors, userIcons } from "../../../utils/mef";
import SubscriberManagement from "../UserManagement/SubscriberManagement";

export default function SubscriberTag(props) {
  const [open, handle] = React.useState(false);

  if (props.id !== undefined && props.id !== null && parseInt(props.id) > 0)
    return (
      <span>
        <Tag
          icon={userIcons[2]}
          key="ut"
          style={{ backgroundColor: userColors[2] }}
          onClick={() => handle(true)}
          interactive={true}
        >
          {i18n.t("userType2")} n°{props.id}
        </Tag>
        {open && <SubscriberManagement
          server={props.server}
          id={props.id}
          onClose={() => {
            handle(false)
          }}
          onUpdate={() => {
            handle(false)
          }}
          parkLookup={props.parkLookup}
          deviceLookup={props.deviceLookup}
        />
        }</span >
    );
  else return (null);
}